/* @import '../../../node_modules/flickity/css/flickity.css'; */
/* @import '../../../node_modules/flickity-fullscreen/fullscreen.css'; */
@import '../../../node_modules/swiper/swiper-bundle.min.css';

.hidden {
  display: none;
}

:host {
  display: block;
  font-family: inherit !important;
}

.carouselWrapper {
  min-height: var(--as-carousel-ch,var(--ascarousel-ch, 400px));
  margin: auto;
}

.carouselWrapper.fullScreen {
  min-height: 0px;
}

.flickity-enabled.is-fullscreen {
  z-index: 100000;
}


.fs-as-carousel.is-fullscreen .carousel-cell .bgoverlay {
  background: rgba(0,0,0,0.7);
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 10000000000;
}

.fs-as-carousel.is-fullscreen .carousel-cell.is-selected .bgoverlay {
  display: none;
}


.as-carousel-loading {
  display: flex;
}

.as-carousel-loading .carousel-cell {
  flex-grow: 0;     /* do not grow   - initial value: 0 */
flex-shrink: 0;   /* do not shrink - initial value: 1 */
flex-basis: calc(var(--as-carousel-ch,var(--ascarousel-ch, 400px)) * 9/16); /* width/height  - initial value: auto */
}

/* default full-width cells */
.carousel-cell {
  width: calc(var(--as-carousel-ch,var(--ascarousel-ch, 400px)) * 9/16);
  height: var(--as-carousel-ch,var(--ascarousel-ch, 400px));
  margin-right: 10px;
  padding: 0px;
  /* border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px; */
  overflow: hidden;
}

.sizemini .carousel-cell {
  margin-right: 6px;
}

.fs-as-carousel.is-fullscreen .carousel-cell  {
  /* top: calc(15vh);
  height: calc(70vh); */
  height: 100%;
  width: 100%;
  max-width: 480px;
  display: -webkit-box;
  display: -webkit-flex;
  display:         flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  -webkit-align-items: center;
          align-items: center;
  /* opacity: 0.3; */
  scale: 0.7;
  /* -webkit-filter: blur(5px);
  filter: blur(5px); */
  -webkit-transition: opacity 0s, -webkit-transform 0s, transform 0s;
  transition: opacity 0s, transform 0s, filter 0s;
  z-index: calc((var(--position) - var(--abs)));
}

@media(max-width: 600px) {
  .fs-as-carousel.is-fullscreen .carousel-cell {
  border-radius: 0px;
  -webkit-border-radius: 0px;
  -moz-border-radius: 0px;
  }
}

.fs-as-carousel.is-fullscreen .carousel-cell.is-selected {
  scale: 1;
  z-index: 100000;
  top: 0;
  height: 100%;
  width: 100%;
  max-width: 480px;
  opacity: 1;
  -webkit-transform: scale(1);
          transform: scale(1);
  -webkit-filter: none;
          filter: none;
}

.fullScreenCarousel {
  visibility: hidden;
  height: 0px;
  opacity: 0;
  transition: visibility 0.3s, z-index 0.3s;
  -webkit-transition: visibility 0.3s, z-index 0.3s;
}
.fullScreenCarousel.isOpen {
  visibility: inherit;
  opacity: 1;
  z-index: 2147483647;
  position: fixed;
}

.flickity-button:disabled {
  display: none;
}

.flickity-prev-next-button {
  width: 40px;
  height: 40px;
}

.flickity-prev-next-button.next {
  right: 6px;
}

.flickity-prev-next-button.prev {
  left: 6px;
}

.flickity-button {
  background: #fff;
  color: #999;
}

@media screen and ( max-width: 600px ) {
  /* half-width cells for larger devices */
  /* .carousel-cell { width: 25%; } */
  .fs-carousel.is-fullscreen .carousel-cell  {
    max-width: auto;
  }
  .flickity-enabled.is-fullscreen .flickity-fullscreen-button-exit {
    display: none;
  }
}

@media screen and (max-width: 400px) {
  /* .carousel-cell {
    width: z;
    height: 304px;
    margin-right: 8px;
    padding: 0px;
  } */
}


.cards {
  background: #fff;
  height: 100%;
  width: 100%;
  overflow: hidden;
  box-shadow: 5px 8px 15px -10px rgba(0,0,0,0.25);
  position: relative;
  border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
}
.cards.fullheight {
  position: absolute;
  top: 0px;
  left: 0px;
}
.cards img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.card_image {
  width: 100%;
  height: 100%;
}
.card_image.loading {
  width: 100%;
  height: 100%;
}
.card_title {
  padding: 8px;
  font-size: 22px;
  font-weight: 700;
  position: absolute;
  bottom: 0px;
  left: 0px;
}
.card_title.loading {
  width: 50%;
  height: 1rem;
  margin: 1rem;
  border-radius: 3px;
  position: relative;
}
.card_description {
  padding: 8px;
  font-size: 16px;
}
.card_description.loading {
  height: 3rem;
  margin: 1rem;
  border-radius: 3px;
}
.loading {
  position: relative;
  background: #cccccc;
}
.fullscreen .loading {
  background: #3a3a3a;
}
.loading:after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  transform: translateX(-100px);
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  animation: loading 0.8s infinite;
}
.fullscreen .loading:after {
  background: linear-gradient(to right, #3a3a3a 0%, #3f3f3f 10%, #4a4a4a 20%, #3f3f3f 30%, #3a3a3a 50%, #3a3a3a 100%);
}

.flickity-button {
  background: rgba(45, 45, 45, 0.7) !important;
  color: #fff !important;
  border: none !important;
  outline: none !important;
}

.flickity-prev-next-button {
  width: 32px;
  height: 32px;
}

.flickity-prev-next-button .flickity-button-icon {
  left: 25%;
  top: 25%;
  width: 50%;
  height: 50%;
}

.carouselWrapper.fullscreen .flickity-button {
  background: rgba(255, 255, 255, 0.5) !important;
  color: #ccc !important;
}

.carouselWrapper.fullscreen .flickity-prev-next-button {
  width: 40px;
  height: 40px;
}

.carouselWrapper.fullscreen .flickity-prev-next-button .flickity-button-icon {
  left: 20%;
  top: 20%;
  width: 60%;
  height: 60%;
}

.swiper-button-next, .swiper-button-prev {
  background: rgba(45, 45, 45, 0.7) !important;
  color: #fff !important;
  border: 1px solid #fff;
  border-radius: 50%;
  width: 38px;
  height: 38px;
}

.swiper-button-prev:after, .swiper-rtl .swiper-button-next:after {
  content: " ";
  border-left: 2px solid #fff;
  border-bottom: 2px solid #fff;
  width: 10px;
  height: 10px;
  transform: rotate(45deg);
  cursor: pointer;
  display: block;
  margin-right: -4px;
}

.swiper-button-next:after, .swiper-rtl .swiper-button-prev:after {
  content: " ";
  border-right: 2px solid #fff;
  border-top: 2px solid #fff;
  width: 10px;
  height: 10px;
  transform: rotate(45deg);
  cursor: pointer;
  display: block;
  margin-left: -4px;
}



@keyframes loading {
  100% {
      transform: translateX(100%);
  }
}